import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getArenas(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`arenas` + (page ? range : ''))
    },

    getFilteredArenas(filter, page, size, sort) {
        return api.get(`arenas` + buildListQuery({ filter, page, size, sort }))
    },

    getArena(id) {
        return api.get(`arenas/${id}`)
    },

    createArena(data) {
        return api.post('arenas', data)
    },

    updateArena(id, data) {
        return api.put(`arenas/${id}`, data)
    },

    uploadFile(formData) {
        return api.uploadFile('uploads/arena', formData)
    },

    deleteArena(id) {
        return api.delete(`arenas/${id}`)
    }
}
